// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3F8Bw","content":"styles_content__2hngH","checkbox":"styles_checkbox__2HwSI","checkboxLabel":"styles_checkboxLabel__2gT8h"};